export default "__VITE_ASSET__D48k1fZl__"